<div class="dialog-container">
  <ng-content></ng-content>
</div>
